import React from "react";
import PaymentManagement from "./index";
import {Route} from "react-router-dom";
import LandingPage from "./landingPage";
import HelpPage from "../../../commonComponents/helpPage";
import Lots from "./lots";
import Projects from "./projects";
import Import from "./import";
import Transactions from "./tranasactions";

const PaymentManagementRoutes = <Route exact path="payment-management" element={<PaymentManagement/>}>
    <Route index element={<LandingPage/>}/>
    <Route path="help" element={<HelpPage site={"crm"} module={"payment"}/>}/>
    <Route path="lots">
        <Route index element={<Lots/>}/>
    </Route>
    <Route path="projects">
        <Route index element={<Projects/>}/>
    </Route>
    <Route path="transactions">
        <Route index element={<Transactions/>}/>
    </Route>
    <Route path="import">
        <Route index element={<Import/>}/>
    </Route>
</Route>

export default PaymentManagementRoutes
